import { useIntl } from 'react-intl';

import Tooltip from 'src/componentes/tooltip';
import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';

import { BOW_TIE_SIDE } from '../constants';
import { formatWeight, hasValue } from '../utils';

function TooltipRow({ label, value }) {
  return (
    <div className="tw:grid tw:grid-cols-[88px_minmax(0,1fr)] tw:gap-2.5 tw:text-[11px]/[1.35]">
      <span className="tw:font-semibold tw:text-[#aeb9c6]">{label}</span>
      <span className="tw:wrap-anywhere tw:text-white">{value}</span>
    </div>
  );
}

function BowTieControlTooltip({ control, side, branch, children }) {
  const intl = useIntl();
  const { terms: resources, decimalSeparator, thousandsSeparator } = useAuth();
  const isPreventive = side === BOW_TIE_SIDE.PREVENTIVO;
  const effectiveness = control?.ultimaEfetividade;
  const hasWeight = hasValue(control?.peso);
  const controlType = capitalizeFirstLetter(
    intl.formatMessage(
      { id: isPreventive ? 'controlePreventivo' : 'controleCorretivo' },
      { pontodecontrole: resources?.pontodecontrole }
    )
  );
  const branchType = capitalizeFirstLetter(
    isPreventive
      ? resources?.pontosproblematicos || ''
      : resources?.consequencias || ''
  );
  const responsibleLabel = capitalizeFirstLetter(
    intl.formatMessage(
      { id: 'responsavel' },
      { responsavel: resources?.responsavel }
    )
  );

  return (
    <Tooltip
      className="tw:w-105 tw:rounded-[9px] tw:bg-gray-800 tw:p-0 tw:text-wrap tw:shadow-[0_8px_24px_rgba(15,23,42,0.24)]"
      maxWidth="calc(100vw - 32px)"
      textAlign="left"
      hideArrow
      sideOffset={6}
      text={
        <div className="tw:p-3">
          <div className="tw:mb-2 tw:text-[13px]/[1.35] tw:font-semibold tw:text-white">
            {control.nome}
          </div>
          <div
            className={`tw:mb-2.5 tw:inline-flex tw:rounded-[10px] tw:border tw:border-solid tw:px-1.75 tw:py-0.75 tw:text-[10px]/[1.2] tw:font-semibold ${
              isPreventive
                ? 'tw:border-[#5ec2cd] tw:bg-[#2b9fad]/20 tw:text-[#a8e3e9]'
                : 'tw:border-[#efb96f] tw:bg-[#de922f]/20 tw:text-[#f6d7a9]'
            }`}
          >
            {controlType}
          </div>
          <div className="tw:flex tw:flex-col tw:gap-1.75 tw:border-t tw:border-white/14 tw:pt-2.25">
            <TooltipRow label={branchType} value={branch.nome} />
            <TooltipRow label={responsibleLabel} value={control.responsavel} />
            {hasWeight && (
              <TooltipRow
                label={capitalizeFirstLetter(
                  intl.formatMessage({ id: 'peso' })
                )}
                value={`${formatWeight(
                  control.peso,
                  decimalSeparator,
                  thousandsSeparator
                )}%`}
              />
            )}
            {hasValue(effectiveness) && (
              <TooltipRow
                label={capitalizeFirstLetter(
                  intl.formatMessage({ id: 'label.efetividade' })
                )}
                value={effectiveness}
              />
            )}
          </div>
        </div>
      }
    >
      {children}
    </Tooltip>
  );
}

export default BowTieControlTooltip;
